<template>
  <div class="Wdgt-Search-Section-Ttl" :class="get_flexLayout">
    <p class="Wdgt-Search-Section-Ttl__txt">
      <img class="Wdgt-Search-Section-Ttl__icon" :src="get_ttlIcon" :alt="props.iconName" width="16px" height="16px" />
      <slot />
    </p>
    <p class="Wdgt-Search-Section-Ttl__prefix" v-if="get_prefix">{{ get_prefix }}</p>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  //-----------------------------------------------
  const props = defineProps(Props());
  //-----------------------------------------------
  //Определить иконку тайтла
  const get_ttlIcon = computed(() => {
    switch (props.iconName) {
      case 'trend':
        return require('@shared/images/icons/trendCoins.svg');
      case 'market':
        return require('@shared/images/icons/marketNow.svg');
      case 'top':
        return require('@shared/images/icons/topCoins2.webp');
      case 'loser':
        return require('@shared/images/icons/loserIcon.webp');
      case 'trend_nft':
        return require('@shared/images/icons/trendNft.webp');
    }
  })
  //Взять текст префикса
  const get_prefix = computed(() => props.prefix);
  //Определить модификатор флекс верстки
  const get_flexLayout = computed(() => props.isJustify ? 'Wdgt-Search-Section-Ttl--space-between' : '');
</script>

<style lang="scss">
  @import "./styles/Wdgt-Search-Section-Ttl";
</style>
